/*
 * @Author: zhengshuhua
 * @Date: 2021-09-14 09:24:25
 * @LastEditors: zhaozhuo
 * @LastEditTime: 2022-03-16 15:37:27
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\directive\index.js
 */
import Vue from 'vue'
import authorizeFunction from './authorizeFunction/index'
const directives = {
	'authorizeFunction': authorizeFunction
}
export const installFn = function() {
	Object.keys(directives).map(item => {
		Vue.directive(item, directives[item])
	})
}
installFn()
